import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NG_SELECT_DEFAULT_CONFIG, NgSelectModule } from '@ng-select/ng-select'
import { NgxMyDatePickerModule } from 'ngx-mydatepicker'
import { AlertContainerComponent } from './alert/alert-container/alert-container.component'
import { AlertComponent } from './alert/alert.component'
import { AlertService } from './alert/shared/alert.service'
import { CapitalizePipe } from './capitalize.pipe'
import { CollapseComponent } from './collapse/collapse.component'
import { DateInputComponent } from './date-input/date-input.component'
import { EmpresaSelectComponent } from './empresa-select/empresa-select.component'
import { EqualsToDirective } from './equals-to.directive'
import { HorizontalInputContainerComponent } from './horizontal-input-container/horizontal-input-container.component'
import { LogoBandeiraComponent } from './logo-bandeira/logo-bandeira.component'
import { LogoOperadoraComponent } from './logo-operadora/logo-operadora.component'
import { MaxDirective } from './max.directive'
import { MinDirective } from './min.directive'
import { NaoInformadoPipe } from './nao-informado.pipe'
import { NumberOnlyDirective } from './number-only.directive'
import { PaginationComponent } from './pagination/pagination.component'
import { SelectComponent } from './select/select.component'
import { TooltipDirective } from './tooltip.directive'
import { VerticalInputContainerComponent } from './vertical-input-container/vertical-input-container.component'
import { FormatNumberPipe } from './format-number.pipe'
import { PopupInformativoAvaComponent } from './ava/popup-informativo.component'
import { PhoneInputComponent } from './telefone-input/telefone-input.component'

@NgModule({
    imports: [
        CommonModule,
        BrowserAnimationsModule,
        FormsModule,
        NgxMyDatePickerModule.forRoot(),
        NgSelectModule,
    ],
    declarations: [
        TooltipDirective,
        LogoOperadoraComponent,
        LogoBandeiraComponent,
        VerticalInputContainerComponent,
        DateInputComponent,
        SelectComponent,
        NaoInformadoPipe,
        EmpresaSelectComponent,
        AlertContainerComponent,
        AlertComponent,
        PaginationComponent,
        MinDirective,
        MaxDirective,
        CollapseComponent,
        EqualsToDirective,
        NumberOnlyDirective,
        HorizontalInputContainerComponent,
        CapitalizePipe,
        FormatNumberPipe,
        PopupInformativoAvaComponent,
        PhoneInputComponent
    ],
    providers: [
        AlertService,
        {
            provide: NG_SELECT_DEFAULT_CONFIG,
            useValue: {
                notFoundText: 'Nenhum resultado encontrado.',
                loadingText: 'Pesquisando...',
            },
        },
    ],
    exports: [
        CommonModule,
        FormsModule,
        NgxMyDatePickerModule,
        NgSelectModule,
        TooltipDirective,
        LogoOperadoraComponent,
        LogoBandeiraComponent,
        VerticalInputContainerComponent,
        DateInputComponent,
        SelectComponent,
        NaoInformadoPipe,
        EmpresaSelectComponent,
        AlertContainerComponent,
        PaginationComponent,
        CollapseComponent,
        EqualsToDirective,
        NumberOnlyDirective,
        HorizontalInputContainerComponent,
        CapitalizePipe,
        FormatNumberPipe,
        PopupInformativoAvaComponent,
        PhoneInputComponent
    ],
})
export class AppCommonModule {}



// WEBPACK FOOTER //
// ./src/app/common/common.module.ts